import { Image } from "@mcleod/components";
import { MainMenu } from "./MainMenu";
import { MenuFavorites } from "./MenuFavorites";
import { MenuTreeNode, MenuTreeNodeProps } from "./MenuTreeNode";

export class MenuTreeNodeLeaf extends MenuTreeNode {
    private favoriteImage: Image;
    private mainMenu: MainMenu;
    constructor(mainMenu: MainMenu, props?: Partial<MenuTreeNodeProps>) {
        super({
            color: "component.palette.menu.secondaryColor",
            selectOnHover: true,
            ...props
        });
        this.mainMenu = mainMenu;
        this.label.setProps({themeKey: "menu.leafNodeLabel"});

        this._element.style.marginLeft = "";
        this.createFavoriteButton();

        const menuLauncher = mainMenu.menuLauncher;
        this.contextMenuItems = () => [
            { text: "Open in New Tab", onClick: () => menuLauncher.openPage(this.menuItem, true, true) },
            { text: "Open in New Window", onClick: () => menuLauncher.openPage(this.menuItem, true, false) }
        ]
        this.addClickListener(menuLauncher.openPageOnClick(this.menuItem, false));
    }

    doOnSelectionChanged() {
        this.syncFavoriteButton();
    }

    private createFavoriteButton() {
        this.favoriteImage = new Image({
            themeKey: "menu.favoriteImage",
            stroke: "caution.dark",
            onClick: () => this.toggleFavorite(),
            style: { visibility: "hidden" }
        });

        this.panel.add(this.favoriteImage);
    }

    async removeFavorite() {
        const favoriteId = MenuFavorites.getFavorites()?.find(favorite => favorite.get("path") === this.menuItem.path)?.get("id");
        if (favoriteId == null)
            return;

        await this.executeFavoriteAction(() => MenuFavorites.removeFavorite(favoriteId));
    }

    async toggleFavorite() {
        await this.executeFavoriteAction(() => MenuFavorites.addOrRemoveFavorite(this.component, this.menuItem));
    }

    private async executeFavoriteAction(action: () => Promise<void>) {
        if (this.favoriteImage.busy === true)
            return;
        try {
            await this.favoriteImage.makeBusyWhile(action());
        } finally {
            this.syncFavoriteButton();
        }
    }

    private syncFavoriteButton() {
        if (this.isSelected()) {
            const rightPosition = this.calcFavoriteRightPosition();
            this.favoriteImage.setProps({
                fill: MenuFavorites.isFavorite(this.menuItem) ? "caution.dark" : "transparent",
                style: {
                    visibility: "visible",
                    position: "absolute",
                    right: `${rightPosition}px`
                }
            });
        } else {
            this.favoriteImage.style.visibility = "hidden";
        }
    }

    private calcFavoriteRightPosition(): number {
        const treeElement = this.getTree()?._element;
        const scrollbarWidth = treeElement ? (treeElement.offsetWidth - treeElement.clientWidth) : 0;
        return this.mainMenu.headerStarOffset - scrollbarWidth;
    }
}
